module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-wizard"
  }, [_c('div', {
    staticClass: "d-wizard__filters",
    class: {
      'd-wizard__filters--locked': _vm.isClosed
    }
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label marg-05-bottom"
  }, [_vm._v("Vælg medarbejder")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "do-select",
    attrs: {
      "disabled": _vm.isClosed
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg person")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n          " + _vm._s(user.name) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Første og sidste arbejdsdag (begge dage inklusiv)")]), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate,
      "allowSameDate": true
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "d-wizard__error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (!_vm.isPeriodValid) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("Vælg en medarbejder og en periode for at se opgørelsen.")]) : (_vm.isLoadingStatement && !_vm.statement) ? _c('div', {
    staticClass: "d-wizard__loading"
  }, [_vm._v("Henter timeopgørelse...")]) : _vm._e(), _vm._v(" "), (_vm.isPeriodValid && _vm.statement) ? [_c('div', {
    staticClass: "d-wizard__status",
    class: {
      'd-wizard__status--closed': _vm.isClosed
    }
  }, [(_vm.isClosed) ? _c('span', [_c('b', [_vm._v("Opgørelsen er lukket")]), _vm._v(" " + _vm._s(_vm.closedLabel) + ". Genåbn den for at ændre periode eller opgørelsesmetode.\n      ")]) : _c('span', [_vm._v("Opgørelsen er åben og kan ændres. Luk den, når den er færdig.")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit': !_vm.isClosed
    },
    attrs: {
      "disabled": _vm.isTogglingClosed || _vm.isLoadingStatement
    },
    on: {
      "click": function($event) {
        return _vm.setClosed(!_vm.isClosed)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isClosed ? 'Genåbn opgørelse' : 'Gem og luk opgørelse') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-overview"
  }, [_c('section', {
    staticClass: "d-overview__col"
  }, [_c('h3', {
    staticClass: "d-overview__title"
  }, [_vm._v("Oprindelig "), _c('span', [_vm._v(_vm._s(_vm.schoolYearName))])]), _vm._v(" "), (_vm.isLoadingOriginal) ? _c('div', {
    staticClass: "d-wizard__loading"
  }, [_vm._v("Henter årsnorm...")]) : [_c('table', {
    staticClass: "d-table d-table__overview"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.originalNormBody), function(item) {
    return _c('tr', {
      key: item.title
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), (_vm.originalNormFooter) ? _c('tfoot', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.originalNormFooter.title))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.originalNormFooter.value))])])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__overview"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalWorkHours)))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.originalWorkHours)))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.originalScheduledTotal)))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.originalWorkHours - _vm.originalScheduledTotal)))])]), _vm._v(" "), _vm._l((_vm.summaryTypes), function(type) {
    return _c('tr', {
      key: 'original-' + type
    }, [_c('td', [_vm._v(_vm._s(_vm.getMasterTypeTitle(type)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalByType(type).assigned)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).assigned)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).scheduled)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).assigned - _vm.originalByType(type).scheduled)))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                Rest\n                "), (_vm.restLabel(_vm.originalRest)) ? _c('span', {
    class: ['d-overview__rest-status', _vm.restBadgeClass(_vm.originalRest)]
  }, [_vm._v(_vm._s(_vm.restLabel(_vm.originalRest)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalRest)))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_c('span', {
    class: _vm.restBadgeClass(_vm.originalRest)
  }, [_vm._v(_vm._s(_vm.formatSigned(_vm.originalRest)))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])]], 2), _vm._v(" "), _c('section', {
    staticClass: "d-overview__col d-overview__col--active"
  }, [_c('h3', {
    staticClass: "d-overview__title"
  }, [_vm._v("Opgjort "), _c('span', [_vm._v(_vm._s(_vm.periodFormatted))])]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__overview"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Periode")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.periodFormatted))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.employmentPercentLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.hoursPerWeek)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bruttotid "), _c('span', {
    staticClass: "d-overview__days"
  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.brutto_dage)) + " dage)")])]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.statement.brutto_tid_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Søgnehelligdage "), _c('span', {
    staticClass: "d-overview__days"
  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.helligdage_dage)) + " dage)")]), _vm._v(" "), (_vm.holidays.length) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        zIndex: 999999992
      }),
      expression: "{arrow: true, zIndex: 999999992}"
    }],
    staticClass: "icon-question3",
    attrs: {
      "content": _vm.holidaysTooltip
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.statement.soegne_helligdage_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "d-overview__vacation"
  }, [_vm._v("\n                Ferie\n                "), _c('input', {
    staticClass: "d-overview__input",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "disabled": _vm.isClosed
    },
    domProps: {
      "value": _vm.numberInput('vacation_days_taken')
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "mouseup": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        return _vm.setNumber('vacation_days_taken', $event.target.value)
      },
      "blur": function($event) {
        return _vm.flushNumberSave('vacation_days_taken')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-overview__days"
  }, [_vm._v("dage afholdt i perioden")])])]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.statement.feriedage_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Elevdage i perioden")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.schoolDaysInPeriod))])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Arbejdstid "), _c('span', {
    staticClass: "d-overview__days"
  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.arbejdsdage)) + " dage)")])]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.format(_vm.periodWorkHours)))])])])]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__overview"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.explanationTippy),
      expression: "explanationTippy"
    }],
    staticClass: "icon-question3 d-overview__help",
    attrs: {
      "content": _vm.workHoursExplanation
    }
  }), _vm._v("\n              " + _vm._s(_vm.format(_vm.periodWorkHours)) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.summaryTypes), function(type) {
    return _c('tr', {
      key: 'period-' + type
    }, [_c('td', [_vm._v(_vm._s(_vm.getMasterTypeTitle(type)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: (_vm.explanationTippy),
        expression: "explanationTippy"
      }],
      staticClass: "icon-question3 d-overview__help",
      attrs: {
        "content": _vm.typeExplanation(type)
      }
    }), _vm._v("\n              " + _vm._s(_vm.format(_vm.groupHoursByType(type))) + "\n            ")])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Rest\n              "), (_vm.restLabel(_vm.rest)) ? _c('span', {
    class: ['d-overview__rest-status', _vm.restBadgeClass(_vm.rest)]
  }, [_vm._v(_vm._s(_vm.restLabel(_vm.rest)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.explanationTippy),
      expression: "explanationTippy"
    }],
    staticClass: "icon-question3 d-overview__help",
    attrs: {
      "content": _vm.restExplanation
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.restBadgeClass(_vm.rest)
  }, [_vm._v(_vm._s(_vm.formatSigned(_vm.rest)))])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-wizard__intro"
  }, [_c('h3', {
    staticClass: "d-overview__title"
  }, [_vm._v("Timeopgørelse for perioden")]), _vm._v(" "), _c('div', {
    staticClass: "do-warning d-wizard__legend"
  }, [_c('b', [_vm._v("Opgørelsesmetode:")]), _vm._v(" "), _c('ol', {
    staticClass: "d-wizard__legend-list"
  }, _vm._l((_vm.methods), function(method) {
    return _c('li', {
      key: method.id
    }, [_c('b', [_vm._v(_vm._s(method.title) + ":")]), _vm._v(" " + _vm._s(method.description))])
  }), 0)])]), _vm._v(" "), (!_vm.groups.length) ? _c('p', [_vm._v("Der er ingen opgaver for personen i perioden.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('table', {
      key: group.type,
      staticClass: "do-table",
      class: {
        'do-table--locked': _vm.isClosed
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('th', {
      staticClass: "d-dates",
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Dato")]), _vm._v(" "), _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          zIndex: 999999992
        }),
        expression: "{arrow: true, zIndex: 999999992}"
      }],
      staticClass: "d-method-group",
      attrs: {
        "colspan": _vm.methods.length,
        "content": "Vælg én metode for hver linje. Timerne i perioden regnes ud fra den valgte metode."
      }
    }, [_vm._v("\n            Vælg opgørelsesmetode "), _c('span', {
      staticClass: "icon-question3"
    })]), _vm._v(" "), _c('th', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          zIndex: 999999992
        }),
        expression: "{arrow: true, zIndex: 999999992}"
      }],
      attrs: {
        "rowspan": "2",
        "content": "Timerne i perioden efter den valgte metode. Ved Egen vurdering tastes tallet her."
      }
    }, [_vm._v("\n            Timer i perioden "), _c('span', {
      staticClass: "icon-question3"
    })])]), _vm._v(" "), _c('tr', _vm._l((_vm.methods), function(method) {
      return _c('th', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            zIndex: 999999992
          }),
          expression: "{arrow: true, zIndex: 999999992}"
        }],
        key: method.id,
        staticClass: "d-method",
        attrs: {
          "content": method.description
        }
      }, [_vm._v("\n            " + _vm._s(method.title) + " "), _c('span', {
        staticClass: "icon-question3"
      })])
    }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.key
      }, [_c('td', [_vm._v(_vm._s(row.task.name)), (row.task.substitute) ? _c('span', [_vm._v(" (vikar)")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "d-dates"
      }, [_vm._v(_vm._s(_vm.formatDateRange(row.task.from_date, row.task.to_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(row.assigned)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(row.scheduled)))]), _vm._v(" "), _vm._l((_vm.methods), function(method) {
        return _c('td', {
          key: method.id,
          staticClass: "d-method",
          class: {
            'd-method--selected': _vm.rowState(row).method === method.id
          },
          on: {
            "click": function($event) {
              return _vm.setMethod(row, method.id)
            }
          }
        }, [_c('label', {
          staticClass: "d-method__label"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": 'method-' + row.key,
            "disabled": _vm.isClosed
          },
          domProps: {
            "value": method.id,
            "checked": _vm.rowState(row).method === method.id
          },
          on: {
            "change": function($event) {
              return _vm.setMethod(row, method.id)
            }
          }
        })])])
      }), _vm._v(" "), _c('td', {
        staticClass: "d-period-hours"
      }, [(_vm.isManualMethod(_vm.rowState(row).method)) ? _c('input', {
        ref: 'period-' + row.key,
        refInFor: true,
        staticClass: "d-method__input",
        attrs: {
          "type": "text",
          "inputmode": "decimal",
          "disabled": _vm.isClosed
        },
        domProps: {
          "value": _vm.rowState(row).manual[_vm.rowState(row).method]
        },
        on: {
          "input": function($event) {
            _vm.setManual(row, _vm.rowState(row).method, $event.target.value)
          }
        }
      }) : _c('b', [_vm._v(_vm._s(_vm.format(_vm.rowHours(row))))])])], 2)
    }), _vm._v(" "), _c('tr', {
      staticClass: "d-diff"
    }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(group.assigned)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(group.scheduled)))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": _vm.methods.length
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(_vm.groupHours(group))))])])], 2)])
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Grundoplysninger")])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Fordeling")])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Forskel")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Grundoplysninger")])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Fordeling")])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer i perioden")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18c2f64c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursWorkedHoursStatement.vue
// module id = 1778
// module chunks = 1